import React, {useEffect, useState, useContext} from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import 'firebase/compat/analytics';
import {init} from '../utils/initFirebase'
import DiceHistorical from '../components/DiceHistorical';
import DiceRoll from '../components/DiceRoll';
import UserContext from '../context/UserContext';
import CampaignContext from '../context/CampaignContext';
import '../styles/character.css';
import '../styles/modal.css';
import {getRoll, getRandomValue} from '../utils/dice';
import { useDiceAnimSetting } from '../hooks/useDiceAnimSetting';
import { useDiceColorSetting } from '../hooks/useDiceColorSetting';
import { useHideChatSetting } from '../hooks/useHideChatSetting';
import DiceAnimationOverlay, { ANIM_TOTAL_MS } from '../components/DiceAnimationOverlay';
import {
  BrowserView,
  MobileView,
  isMobile,
} from "react-device-detect";
import { toast } from 'react-toastify';
import DmCompany from '../components/DmCompany';
import {getLabelDice} from '../utils/dice'
import {useHistory} from "react-router-dom";
import CampaignNotes from '../components/CampaignNotes';
import DmCharacterPanel from '../components/DmCharacterPanel';
import i18next from 'i18next';
import CampaignSettings from '../components/CampaignSettings';
import {ImagePanelAdmin} from '../components/ImagePanel';
import AmbianceWidget from '../components/AmbianceWidget';
import TimerWidget from '../components/TimerWidget';
import CampaignMapAdmin from '../components/CampaignMapAdmin';
import CampaignLibrary from '../components/CampaignLibrary';
import { UserIcon, CogIcon, AnnotationIcon, GlobeAltIcon, ChatIcon } from '@heroicons/react/outline';
import { uid } from 'uid';
import { generateNpc } from '../utils/npcGenerator';
import { useRollToasts } from '../hooks/useRollToasts';

init();
const db = firebase.firestore();

const Dm = (props) => {
  const {user} = useContext(UserContext);
  const {campaign, updateCampaign} = useContext(CampaignContext)
  const [rollList, setRollList] = useState([]);
  const [hideRollSwitch,setHideRollSwitch] = useState(false);
  const [company, setCompany] = useState([]);
  const [view, setView] = useState('company');
  const [diceAnim, setDiceAnim] = useState(null);
  const [spectatorAnim, setSpectatorAnim] = useState(null);
  const [debugD10, setDebugD10] = useState(false);
  const [animEnabled, toggleAnim] = useDiceAnimSetting();
  const [diceColor] = useDiceColorSetting();
  const [hideChat, setHideChat] = useHideChatSetting();
  const [sheetUid, setSheetUid] = useState(null);
  useRollToasts(rollList, hideChat, campaign, user);

  const broadcastDiceAnim = (diceType, value) => {
    firebase.database().ref(`diceAnim/${campaign.uid}`).set({ diceType, value, userUid: user.uid, rolledAt: Date.now() });
    setTimeout(() => firebase.database().ref(`diceAnim/${campaign.uid}`).remove(), 8000);
  };
  const history = useHistory();

  useEffect(() => {
    if(campaign.uid){
      getCharactersCompany(campaign);
      const dbRefObject = firebase.database().ref().child(`${campaign.uid}`);
      dbRefObject.on('value', snap => {
        setRollList(Object.values(snap.val() || {}));
      });
      const animRef = firebase.database().ref(`diceAnim/${campaign.uid}`);
      animRef.on('value', snap => {
        const data = snap.val();
        if (!data) return;
        if (data.userUid === user.uid) return;
        if (Date.now() - data.rolledAt > 10000) return;
        setSpectatorAnim({ diceType: data.diceType, value: data.value });
      });
      return () => { dbRefObject.off(); animRef.off(); };
    }
  }, [campaign]);
  
  const REACTION_EMOJIS = ['🎉', '💀', '😬'];

  const handleReact = (rollIdx, emoji) => {
    const updated = rollList.map((r, i) => {
      if (i !== rollIdx) return r;
      const reactions = { ...r.reactions };
      REACTION_EMOJIS.forEach(e => {
        reactions[e] = (reactions[e] || []).filter(uid => uid !== user.uid);
      });
      const hadIt = (r.reactions?.[emoji] || []).includes(user.uid);
      if (!hadIt) reactions[emoji] = [...(reactions[emoji] || []), user.uid];
      return { ...r, reactions };
    });
    firebase.database().ref().child(`${campaign.uid}`).set(updated);
  };

  const sendNewRoll = async (newRoll) => {
    const rolls = Array.isArray(newRoll) ? newRoll : [newRoll];
    if (rolls.length === 0) return;
    const newList = [...rollList, ...rolls];
    firebase.database().ref().child(`${campaign.uid}`).set(newList);
    db.collection('campaigns').doc(campaign.uid).update({ lastRollAt: firebase.firestore.FieldValue.serverTimestamp() }).catch(() => {});
    const first = rolls[0];
    if(isMobile) {
      toast.success(`${getLabelDice(first, campaign, user)} : ${first.value}`, {});
    }
    firebase.analytics().setUserId(user.uid);
    firebase.analytics().setUserProperties({
      name: user.displayName,
      uid: user.uid,
      campaign: campaign.uid,
    });

    const labelStat = first.stat ? first.stat.label : 'Custom'
    firebase.analytics().logEvent('Roll', {
      campaign: campaign.uid,
      type: first.diceType,
      stat: labelStat,
      result: first.value
    });
  }

  const getCharactersCompany = async (currentCampaign) => {
    try {
      const listCharactersGroup = [];
      await db.collection('characters').where('idCampaign', '==', currentCampaign.uid).where('active', '==', true).where('idUser', '!=', currentCampaign.idUserDm).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            listCharactersGroup.push(doc.data())
          });
          setCompany(listCharactersGroup);
        })
        .catch(err => {
          console.log('err',err)
        })
    } catch (error) {
      console.log('error',error);
    }
  }

  const createNpc = async () => {
    const npc = generateNpc();
    const npcUid = uid();
    const data = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      lastUpdateAt: firebase.firestore.FieldValue.serverTimestamp(),
      name: npc.name,
      uid: npcUid,
      idCampaign: campaign.uid,
      idUser: 'npc',
      isNpc: true,
      currentHp: npc.hp,
      maxHp: npc.hp,
      description: '',
      skills: npc.skills,
      characteristics: npc.characteristics,
      isAlchemist: false,
      isMage: false,
      isDeathMage: false,
      inventory: [],
      picture: null,
      active: true,
    };
    try {
      await db.collection('characters').doc(npcUid).set(data);
      getCharactersCompany(campaign);
      toast.success(`${npc.name} ${i18next.t('npc.created')}`, {});
    } catch (error) {
      console.log('createNpc error', error);
      toast.error(i18next.t('npc.error'), {});
    }
  };

  const deleteNpc = async (npcUid) => {
    try {
      await db.collection('characters').doc(npcUid).delete();
      if (sheetUid === npcUid) setSheetUid(null);
      setCompany((prev) => prev.filter((m) => m.uid !== npcUid));
    } catch (error) {
      console.log('deleteNpc error', error);
    }
  };

  const updateCampaignFirestore = async (newCampaignData) => {
    newCampaignData.lastUpdateAt = firebase.firestore.FieldValue.serverTimestamp();
    await db.collection('campaigns').doc(newCampaignData.uid).set(newCampaignData).then(res => {
      toast.success(i18next.t('update succed'), {});
      firebase.analytics().logEvent('updateConfigCampaign', {
        ...newCampaignData
      });
    }).catch(err => {
      toast.error(err, {});
    });
  }

  if(campaign.uid && campaign.idUserDm !== user.uid ) {
    history.goBack();
  }
  if(campaign.idUserDm === user.uid) {
    return (
      <>
      <div className={`containerCharacterView${sheetUid ? ' dmPanelOpen' : ''}`}>
        <div className={`${view === 'company' ? 'DMContainer' : 'DMContainerFull'}${hideChat ? ' chatHidden' : ''}`}>
          <div className='containerInfoComp'>
            <BrowserView className='tabsDetails'>
              <ul className='tabsContainer'>
                <li
                  className={`tab ${view === 'company' ? 'active' : ''}`}
                  onClick={() => {
                    setView('company');
                  }}  
                >
                  {i18next.t('characters')}
                </li>
                <li
                  className={`tab ${view === 'imagePanel' ? 'active' : ''}`}
                  onClick={() => {
                    setView('imagePanel');
                  }}  
                >
                  {i18next.t('illustration.title')}
                </li>
                <li
                  className={`tab ${view === 'map' ? 'active' : ''}`}
                  onClick={() => setView('map')}
                >
                  {i18next.t('map.title')}
                </li>
                <li
                  className={`tab ${view === 'library' ? 'active' : ''}`}
                  onClick={() => setView('library')}
                >
                  {i18next.t('library.title')}
                </li>
                <li
                  className={`tab ${view === 'settings' ? 'active' : ''}`}
                  onClick={() => {
                    setView('settings');
                  }}
                >
                  {i18next.t('settings campaign')}
                </li>
              </ul>
            </BrowserView>
            <MobileView className='tabsDetailsMobile'>
              <ul className='mobileTabsContainer'>
                <li
                  className={`tab ${view === 'company' ? 'active' : ''}`}
                  onClick={() => {
                    setView('company');
                  }}  
                >
                  <UserIcon className='iconTabMobile' />
                </li>
                { rollList.length > 0 && (
                  <li
                    className={`tab ${view === 'diceChat' ? 'active' : ''}`}
                    onClick={() => {
                      setView('diceChat');
                    }}  
                  >
                    <AnnotationIcon className='iconTabMobile' />
                  </li>
                )}
                <li
                  className={`tab ${view === 'map' ? 'active' : ''}`}
                  onClick={() => setView('map')}
                >
                  <GlobeAltIcon className='iconTabMobile' />
                </li>
                <li
                  className={`tab ${view === 'settings' ? 'active' : ''}`}
                  onClick={() => {
                    setView('settings');
                  }}
                >
                    <CogIcon className='iconTabMobile' />
                </li>
              </ul>
            </MobileView>
            <div className='contentDm'>
              {campaign.uid && <TimerWidget campaignUid={campaign.uid} isDm={true} />}
              {company && view === 'company' && (
                <DmCompany
                  reloadCompany={() => {
                    getCharactersCompany(campaign)
                  }}
                  company={company}
                  onOpenSheet={(charUid) => setSheetUid(charUid)}
                  onCreateNpc={createNpc}
                  onDeleteNpc={deleteNpc}
                />
              )}
              {view === 'settings' && (
                <CampaignSettings 
                  campaign={campaign}
                  update={(campagneUpdated) => {
                    updateCampaign(campagneUpdated);
                    updateCampaignFirestore(campagneUpdated);
                  }}
                />
                
              )}
              {view === 'imagePanel' && (
                <ImagePanelAdmin
                  campaignUid={campaign.uid}
                  company={company}
                />
              )}
              {view === 'map' && (
                <CampaignMapAdmin campaignUid={campaign.uid} user={user} />
              )}
              {view === 'library' && (
                <CampaignLibrary campaignUid={campaign.uid} user={user} isDm={true} />
              )}
              {view === 'diceChat' && (
                <DiceHistorical
                  list={rollList}
                  hideRollSwitch={hideRollSwitch}
                  setHideRoll={(val) => { setHideRollSwitch(val) }}
                  onReact={handleReact}
                />
              )}
            </div>
          </div>
          {view === 'company' && !hideChat && (
            <BrowserView className='containerHisto'>
              <DiceHistorical
                list={rollList}
                hideRollSwitch={hideRollSwitch}
                setHideRoll={(val) => { setHideRollSwitch(val) }}
                onReact={handleReact}
                collapsible={true}
                hideChat={hideChat}
                setHideChat={setHideChat}
              />
            </BrowserView>
          )}
          {view === 'company' && hideChat && (
            <BrowserView>
              <button
                className='showChatFab'
                onClick={() => setHideChat(false)}
                title={i18next.t('showChat')}
              >
                <ChatIcon />
              </button>
            </BrowserView>
          )}
          <BrowserView>
            <DiceRoll
              chat={false}
              setNewDice={(valMaxRoll, quantity = 1) => {
                if (quantity > 1) {
                  const rolls = Array.from({ length: quantity }, () => getRandomValue(valMaxRoll));
                  const total = rolls.reduce((a, b) => a + b, 0);
                  sendNewRoll(getRoll(valMaxRoll, campaign.idUserDm, null, user, null, hideRollSwitch, null, total, quantity, rolls));
                } else {
                  const value = getRandomValue(valMaxRoll);
                  broadcastDiceAnim(valMaxRoll, value);
                  if (animEnabled) {
                    setDiceAnim({ diceType: valMaxRoll, value });
                  } else {
                    setTimeout(() => sendNewRoll(getRoll(valMaxRoll, campaign.idUserDm, null, user, null, hideRollSwitch, null, value)), ANIM_TOTAL_MS);
                  }
                }
              }}
              animEnabled={animEnabled}
              onToggleAnim={toggleAnim}
            />
          </BrowserView>
          {diceAnim && (
            <DiceAnimationOverlay
              diceType={diceAnim.diceType}
              finalValue={diceAnim.value}
              diceColor={diceColor}
              onClose={() => {
                sendNewRoll(getRoll(diceAnim.diceType, campaign.idUserDm, null, user, null, hideRollSwitch, null, diceAnim.value));
                setDiceAnim(null);
              }}
            />
          )}
          {spectatorAnim && !diceAnim && animEnabled && (
            <DiceAnimationOverlay
              diceType={spectatorAnim.diceType}
              finalValue={spectatorAnim.value}
              diceColor={diceColor}
              onClose={() => setSpectatorAnim(null)}
            />
          )}
        </div>
      </div>
      {campaign.uid && <CampaignNotes campaignUid={campaign.uid} />}
      {campaign.uid && <AmbianceWidget campaignUid={campaign.uid} isDm={true} />}
      {sheetUid && <DmCharacterPanel characterUid={sheetUid} onClose={() => setSheetUid(null)} sendNewRoll={sendNewRoll} />}
      </>
    );
  } else {
    return null;
  }
}

export default Dm